
import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image } from 'newComponents'
import './styles.scss'

const Speakers = ({ speakers, variant }) => {
  if (!speakers) return null
  const isPage = variant === 'page' ? 'page-variant' : ''

  return (
    <OnVisible className={`speakers-new ${isPage}`}>
      <div className="speakers-container">
        <span className="speakers-title">Speakers</span>
        {speakers.map((speaker) => {
          const { avatar, logo, name, role} = speaker
          return (
            <div className="speakers-speaker" key={name.text}>
              <Image className="speakers-speaker-avatar" image={avatar} />
              <div className="speakers-speaker-text">
                <span className="speakers-speaker-name">{name.text}</span>
                <span className="speakers-speaker-role">{role.text}</span>
                <Image className="speakers-speaker-logo" image={logo} />
              </div>
            </div>
          )
        })}
      </div>
    </OnVisible>
  )
}

export default Speakers
